export default __webpack_public_path__ + "static/media/main.fe1f4c48.png";